(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsDelta', function () {
    return {
      link: function link(scope, element, attrs) {
        var value = parseInt(attrs.value);
        if (value > 0) {
          element.append("<span class='delta positive'>+" + value + "</span>");
        } else if (value < 0) {
          element.append("<span class='delta negative'>" + value + "</span>");
        } else {
          element.append("<span class='delta'>&mdash;</span>");
        }
      }
    };
  });
})();
